<template>
  <div class="textnav">
    <ul class="textnav__wrapper">
      <template v-if="items">
        <li
          v-for="(item, index) in items"
          :key="index"
          class="textnav__item"
        >
          <router-link
            :to="item.href || ''"
            class="textnav__link"
          >
            {{ item.label }}
          </router-link>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    items: { type: Array, default: null },
  },
};
</script>

<style lang="stylus" scoped>
.textnav {
  @extend $typo-nav-text;
  display: flex;
}

.textnav__wrapper {
  display: flex;
  margin: 0 -20px;
}

.textnav__item {
  @extend $typo-nav-text;
  padding: 0 20px;
  text-transform: uppercase;
}

.textnav__link {
  color: alpha($cl-white, 0.3);
  white-space: nowrap;
  &:hover {
    color: $cl-white;
  }
}

.textnav__item >>> .textnav__link.router-link-active {
  font-weight: 700;
  color: $cl-white;
  pointer-events: none;
}
</style>
